export default __webpack_public_path__ + "static/media/Bandit's Armguards of the Howling Moon.34db08ce.jpg";